import PropTypes from 'prop-types';

import { Text, Title, Modal, SimpleGrid, Loader, Stepper, Button, ActionIcon, Stack, Box, Group } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconX } from '@tabler/icons-react';

import { openInNewTab } from '../../utils/card-helpers';
import { coral } from 'theme/colors';
import { semanticColors } from 'theme/semanticColors';

const ResultDialog = ({ open, setOpen, result, isLoading }) => {
  const isSMScreen = useMediaQuery('(max-width: 37.5em)');

  const { flightTitle, departureTime, arrivalTime, origin, destination, bookingLinks, mileageCost } = result || {};

  return (
    <Modal opened={open} onClose={() => setOpen(false)} size="lg" fullScreen={isSMScreen} title="Flight Details">
      <Box p={{ base: 'sm', sm: 'md' }}>
        {isLoading ? (
          <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
            <Loader size={100} />
          </Box>
        ) : (
          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
            <Box>
              <Title order={4}>Flight Details</Title>
              <Text>Carrier - {flightTitle}</Text>
              <Stepper orientation="vertical" active={2} mt="md" size="sm">
                <Stepper.Step
                  label={
                    <Text fw={600} mt="xs">
                      {departureTime}
                    </Text>
                  }
                  description={
                    <>
                      <Text fw={600} c={coral[6]} size="sm">
                        Departure Time
                      </Text>
                      <Text>{origin}</Text>
                    </>
                  }
                />
                <Stepper.Step
                  label={<Text>{arrivalTime}</Text>}
                  description={
                    <>
                      <Text fw={600} c={coral[6]} size="sm">
                        Arrival Time
                      </Text>
                      <Text>{destination}</Text>
                    </>
                  }
                />
              </Stepper>
            </Box>
            <Box>
              <Group justify="space-between" mb="sm">
                <Box>
                  <Title order={4}>Options to Book</Title>
                  <Text size="sm" style={{ lineHeight: 1 }}>
                    Choose your mileage program
                  </Text>
                </Box>
                <Box ta="right">
                  <Title order={4}>Mileage Cost</Title>
                  <Title order={4} c={coral[6]}>
                    {mileageCost} pts
                  </Title>
                </Box>
              </Group>
              <Stack gap="sm">
                {bookingLinks?.map(({ link, label, primary }) => (
                  <Button key={link} fullWidth onClick={() => openInNewTab(link)} variant={primary ? 'filled' : 'outline'}>
                    {label}
                  </Button>
                ))}
              </Stack>
            </Box>
          </SimpleGrid>
        )}
      </Box>
    </Modal>
  );
};

ResultDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  result: PropTypes.object,
  isLoading: PropTypes.bool
};

export default ResultDialog;
